module.exports = __webpack_public_path__ + "static/media/guildhall.0a7789fb.jpg";